"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogBody = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const useStyles = (0, create_use_styles_1.default)(({ spacing }) => ({
    body: {
        padding: spacing("lg"),
    },
}));
function DialogBody({ children, className, ...props }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.body, className), ...props }, children));
}
exports.DialogBody = DialogBody;
exports.default = DialogBody;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlhbG9nLWJvZHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL2RpYWxvZy9kaWFsb2ctYm9keS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0RBQTBCO0FBQzFCLDREQUFvQztBQUVwQyx3RkFBOEQ7QUFLOUQsTUFBTSxTQUFTLEdBQUcsSUFBQSwyQkFBZSxFQUFDLENBQUMsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNsRCxJQUFJLEVBQUU7UUFDSixPQUFPLEVBQUUsT0FBTyxDQUFDLElBQUksQ0FBQztLQUN2QjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRUosU0FBZ0IsVUFBVSxDQUFDLEVBQUUsUUFBUSxFQUFFLFNBQVMsRUFBRSxHQUFHLEtBQUssRUFBbUI7SUFDM0UsTUFBTSxPQUFPLEdBQUcsU0FBUyxFQUFFLENBQUM7SUFFNUIsT0FBTyxDQUNMLHVDQUFLLFNBQVMsRUFBRSxJQUFBLG9CQUFVLEVBQUMsT0FBTyxDQUFDLElBQUksRUFBRSxTQUFTLENBQUMsS0FBTSxLQUFLLElBQzNELFFBQVEsQ0FDTCxDQUNQLENBQUM7QUFDSixDQUFDO0FBUkQsZ0NBUUM7QUFFRCxrQkFBZSxVQUFVLENBQUMifQ==